import React from 'react';
// styles
import styled from 'styled-components';

const LoadTypeLoadIcon = ({ className, ...props }) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Load Type Load"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.2939 17.3716C13.2939 17.8894 12.8741 18.3091 12.3564 18.3091C11.8386 18.3091 11.4189 17.8894 11.4189 17.3716L11.4189 7.653L9.10041 9.97147C8.7343 10.3376 8.1407 10.3376 7.77459 9.97147C7.40847 9.60536 7.40847 9.01177 7.77459 8.64565L11.6342 4.78602L11.6417 4.77864L11.6489 4.77129C12.0069 4.41331 12.5873 4.41331 12.9453 4.77129L12.96 4.78602L16.9522 8.77823C17.3102 9.13621 17.3102 9.71661 16.9522 10.0746C16.5943 10.4326 16.0139 10.4326 15.6559 10.0746L13.2939 7.71259L13.2939 17.3716ZM5.41667 19.1667C4.91041 19.1667 4.5 19.5771 4.5 20.0834C4.5 20.5896 4.91041 21 5.41667 21H18.5833C19.0896 21 19.5 20.5896 19.5 20.0834C19.5 19.5771 19.0896 19.1667 18.5833 19.1667H5.41667Z"
      fill="#54708C"
    />
  </svg>
);

export default styled(LoadTypeLoadIcon)``;
